/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpCategorySyncCategoryResponse } from './CarpCategorySyncCategoryResponse';

export type CarpCategorySyncCategoryResponseApiRespoonse = {
    data?: CarpCategorySyncCategoryResponse;
    status?: CarpCategorySyncCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpCategorySyncCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

